import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { TransportTicketPickerProvider } from './store/TransportTicketPickerContext';
import { ContainerProvider } from '@nine7soft/react-di';
import { diConfig } from './config';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <TransportTicketPickerProvider>
                <ContainerProvider config={diConfig}>
                    <App />
                </ContainerProvider>
            </TransportTicketPickerProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
